import React from 'react';
import { angular2react } from 'angular2react';
// eslint-disable-next-line import/named
import { lazyInjector } from '@app/lazyInjector';
// @ts-ignore
import FeedbackAgents from '@app/listing/appointments/feedback/feedback_agent_notifications.component';

const FeedbackAgentsComponent: React.ComponentClass<any> = angular2react(
  'bbFeedbackAgents',
  FeedbackAgents,
  lazyInjector.$injector,
);

export default FeedbackAgentsComponent;
